export enum CreateResourceStatus {
  draft = 1,
  published = 2,
  inActive = 3,
  deleted = 4,
  formChanged = 0,
  subCategoriesQueryKey= '&categories='
}
